// -------------------------------------
// #FIX JQUERY PASSIVE LISTENER
// -------------------------------------

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {
            passive: !ns.includes("noPreventDefault"),
        });
    },
};

jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {
            passive: !ns.includes("noPreventDefault"),
        });
    },
};

jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, { passive: true });
    },
};

jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, { passive: true });
    },
};

// -------------------------------------
// #FUNCTIONS
// -------------------------------------

jQuery(document).ready(function ($) {
    function debounce(func, wait) {
        var timer = null;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, wait);
        };
    }

    // -------------------------------------
    // Definir variaveis de CSS
    // -------------------------------------

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    var vh = window.innerHeight * 0.01; // Then we set the value in the --vh custom property to the root of the document
    var header = $('#header');

    document.documentElement.style.setProperty('--vh', "".concat(vh, "px")); // We listen to the resize event

    if (header) {
        var headerHeight = header.outerHeight();
        document.documentElement.style.setProperty('--header-height', "".concat(headerHeight, "px"));
    }

    window.addEventListener('resize', debounce(function(){
        // We execute the same script as before
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));

        if (header) {
            headerHeight = header.outerHeight();
            document.documentElement.style.setProperty('--header-height', "".concat(headerHeight, "px"));
        }
    }, 100));

    // -------------------------------------
    // Verificar qual tamanho da barra de rolagem
    // -------------------------------------

    function getScrollbarWidth() {
        // Creating invisible container
        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);

        // Creating inner element and placing it in the container
        var inner = document.createElement('div');
        outer.appendChild(inner);

        // Calculating difference between container's full width and the child width
        var scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
        document.documentElement.style.setProperty('--scrollbar-width', "".concat(scrollbarWidth, "px"));

        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);

        return scrollbarWidth;
    }

    var scrollbar = getScrollbarWidth();

    // -------------------------------------
    // Menu Mobile
    // -------------------------------------

    // Menu mobile vars
    var btnMenuMobile = $(".btn-menu-mobile");
    var menuMobile = $(".menu-mobile");   

    // Open menu mobile
    function openMenuMobile() {
        btnMenuMobile.addClass("is-active");
        menuMobile.addClass("is-active");
        header.addClass("menu-mobile-active");
        $("html").css({ "margin-right": scrollbar + "px", overflow: "hidden" });
    }

    // Close menu mobile
    function closeMenuMobile() {
        btnMenuMobile.removeClass("is-active");
        menuMobile.removeClass("is-active");
        header.removeClass("menu-mobile-active");
        setTimeout(function () {
            $("html").css({ "margin-right": "", overflow: "" });
        }, 300);
    }

    // Trigger menu mobile
    $('[data-menu-mobile="toggle"]').click(function (event) {
        if (menuMobile.hasClass("is-active")) {
            closeMenuMobile();
        } else {
            openMenuMobile();
        }
    });

    // Open submenu mobile
    $(".mobile-nav .menu-item-has-children").click(function (event) {
        $(".mobile-nav .sub-menu .menu-item").click(function (event) {
            event.stopPropagation();
        });
        if ($(this).children(".sub-menu").is(":visible")) {
            $(this).removeClass("is-active");
            $(this).children(".sub-menu").slideUp();
        } else {
            $(this).addClass("is-active");
            $(this).children(".sub-menu").slideDown();
        }
    });

    // -------------------------------------
    // Filter Cities
    // -------------------------------------

    const dropdown = $('.city-dropdown');
    const searchSubmit = $('.cowork-city button[type="submit"]');
    const emptyOption = $('<div class="city-option empty">Nenhuma cidade encontrada.</div>');

    function normalizeText(text) {
        return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    $('#cidade').on('input', function () {
        var inputText = normalizeText($(this).val().toLowerCase());
        dropdown.empty();

        if (inputText === '') {
            searchSubmit.prop('disabled', false);
            dropdown.hide();
            return;
        }

        searchSubmit.prop('disabled', true);

        var filteredCities = cities.filter(function (city) {
            return normalizeText(city.toLowerCase()).includes(inputText);
        });

        if (filteredCities.length === 0) {
            dropdown.append(emptyOption);
            dropdown.show();
        } else {
            filteredCities.forEach(function (city) {
                var option = $('<div class="city-option"><svg viewBox="0 0 24 24"><use href="#icon-location"/></svg>' + city + '</div>');
                option.on('click', function () {
                    $('#cidade').val(city);
                    searchSubmit.prop('disabled', false);
                    dropdown.hide();
                });
                dropdown.append(option);
            });

            dropdown.show();
        }
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('.cowork-input').length) {
            dropdown.hide();
        }
    });

    // -------------------------------------
    // Service Popup
    // -------------------------------------

    const sPopup = $('#s-popup');
    const sPopupOverlay = $('#s-popup-overlay');
    let touchStartX = 0;
    let touchEndX = 0;

    $('[data-s-popup="open"]').click(function () {
        const sItem = $(this).closest('.service-item');
        const title = sItem.data('title');
        const image = sItem.data('image');

        openServicePopup(title, image);
    });

    $('[data-s-popup="close"]').click(function () {
        closeServicePopup();
    });

    // Detecta o início do toque
    sPopup.on('touchstart', function (e) {
        touchStartX = e.originalEvent.touches[0].clientX;
    });

    // Detecta o término do toque
    sPopup.on('touchend', function (e) {
        touchEndX = e.originalEvent.changedTouches[0].clientX;

        // Define a distância mínima para fechar o popup (ajuste conforme necessário)
        const minSwipeDistance = 150;

        // Calcula a distância percorrida
        const swipeDistance = touchEndX - touchStartX;

        // Se a distância for maior que o limite, fecha o popup
        if (swipeDistance > minSwipeDistance) {
            closeServicePopup();
        }
    });

    // Open Service Popup
    function openServicePopup(title, image) {
        $('#s-popup .s-popup-selected h3').text(title);
        $('#s-popup .s-popup-img img').attr('src', image);
        $('#s-popup #input-servico').attr('value', title);

        sPopup.addClass("is-active");
        sPopupOverlay.fadeIn();
        $("html").css({ "margin-right": scrollbar + "px", overflow: "hidden" });
    }

    // Close Service Popup
    function closeServicePopup() {
        sPopup.removeClass("is-active");
        sPopupOverlay.fadeOut();
        setTimeout(function () {
            $("html").css({ "margin-right": "", overflow: "" });
        }, 300);
    }

    // Select Service Form
    $('.s-popup-btn[data-form-btn]').click(function (e) {
        // Remove a classe is-active de todos os botões
        $('.s-popup-btn[data-form-btn]').removeClass('is-active');

        // Adiciona a classe is-active ao botão clicado
        $(this).addClass('is-active');

        // Obtém o valor do atributo data-form do botão clicado
        const formValue = $(this).attr('data-form-btn');

        // Oculta todos os formulários que não correspondem ao botão clicado
        $('.s-popup-form[data-form]').each(function () {
            if ($(this).attr('data-form') === formValue) {
                $(this).fadeIn();
            } else {
                $(this).hide();
            }
        });
    });

    // -------------------------------------
    // Anchor Scroll
    // -------------------------------------

    $('a[href*="#"]:not([href="#"])').click(function (event) {
        event.preventDefault();
        if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
            var el = this;
            var hash = $($(this).attr("href"));
            var target = hash.length ? hash : $("[name=" + this.hash.slice(1) + "]");
            if (target.length) {
                $("html, body").animate({
                    scrollTop: target.offset().top,
                }, 1000);

                // Mudar hash na URL
                history.pushState({}, "", el.href);
            }
        }
    });

    $('a[href="#"]').click(function () {
        $("html, body").animate({
            scrollTop: 0,
        }, 1000);
    });

    // -------------------------------------
    // Magnific Popup
    // -------------------------------------

    $(".gallery-popup, .wp-block-gallery").each(function () {
        // the containers for all your galleries
        $(this).magnificPopup({
            delegate: "a",
            type: "image",
            closeOnContentClick: true,
            closeBtnInside: false,
            fixedContentPos: true,
            tLoading: "Carregando a imagem...",
            mainClass: "mfp-no-margins mfp-fade",
            removalDelay: 300,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                tCounter: '%curr% de %total%' // Markup for "1 of 7" counter
            },
            image: {
                tError: "A imagem não pode ser carregada.",
            },
        });
    });
});

// -------------------------------------
// Modify URL Parameters before Submit
// -------------------------------------

function submitSearchForm() {
    var checkboxes = document.querySelectorAll('input[name="servico"]:checked');
    var servicoValues = Array.from(checkboxes).map(function (checkbox) {
        return checkbox.value;
    }).join(',');

    var cidadeValue = document.getElementById('cidade').value;

    var formAction = document.getElementById('cowork-search-form').getAttribute('action');
    var newURL = formAction + "?";

    // Adiciona os parâmetros ao URL, condicionalmente
    if (cidadeValue) {
        newURL += "cidade=" + encodeURIComponent(cidadeValue);
    }

    if (servicoValues) {
        if (cidadeValue) {
            newURL += "&"; // Adiciona o "&" se já tiver a cidade na URL
        }
        newURL += "servico=" + encodeURIComponent(servicoValues);
    }

    // Redireciona para o novo URL
    window.location.href = newURL;
}

// -------------------------------------
//   AOS
// -------------------------------------

/*
AOS.init({
  // Global settings
  disable: 'mobile', // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll

  // Settings that can be overriden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 1100, // values from 0 to 3000, with step 50ms
  easing: 'ease', // default easing for AOS animations
  once: true, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
});
*/
